"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var certification_watermark_1 = require("@tableau/certification-watermark");
var React = require("react");
var SpacesMediumDs_1 = require("../../../../gen-src/icons/SpacesMediumDs");
var SpacesMediumDsCertified_1 = require("../../../../gen-src/icons/SpacesMediumDsCertified");
var SpacesMediumExtract_1 = require("../../../../gen-src/icons/SpacesMediumExtract");
var SpacesMediumExtractCertified_1 = require("../../../../gen-src/icons/SpacesMediumExtractCertified");
var CertificationWidget_1 = require("../../CertificationWidget");
var FeatureFlagsContext_1 = require("../../featureFlags/FeatureFlagsContext");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var MarkupStyles_1 = require("../../style/MarkupStyles");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var CertifiedIconWrapper = LayoutComponents_1.divWithStyle('CertifiedIconWrapper', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
function isCertified(props) {
    return props.isCertified && !!props.certifier;
}
function getCertifiedIconWithWrapper(hasExtracts) {
    return (React.createElement(CertifiedIconWrapper, null, hasExtracts ? React.createElement(SpacesMediumExtractCertified_1.SvgSpacesMediumExtractCertified, null) : React.createElement(SpacesMediumDsCertified_1.SvgSpacesMediumDsCertified, null)));
}
function getCertificationTooltipProps(markupEditingEnabled, props, urls) {
    var certificationNote = props.certificationNote || '';
    var note = markupEditingEnabled ? React.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: certificationNote }) : certificationNote;
    var certificationTooltipProps = {
        certifier: CertificationWidget_1.getCertifierPropsFromCertifier(props.certifier, urls),
        note: note,
        icon: getCertifiedIconWithWrapper(props.hasExtracts),
        showExtractRefresh: true,
        date: props.extractLastUpdateTime,
        linksDisabled: props.linksDisabled || false,
        zIndex: props.zIndex || undefined,
    };
    return certificationTooltipProps;
}
function DatasourceTypeCell(props) {
    var markupEditingEnabled = React.useContext(FeatureFlagsContext_1.FeatureFlagsContext).markupEditingEnabled;
    if (isCertified(props)) {
        if (props.linksDisabled) {
            return React.createElement(certification_watermark_1.CertificationTooltipComponent, __assign({}, getCertificationTooltipProps(markupEditingEnabled, props)));
        }
        else {
            return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) { return React.createElement(certification_watermark_1.CertificationTooltipComponent, __assign({}, getCertificationTooltipProps(markupEditingEnabled, props, urls))); }));
        }
    }
    else {
        if (props.hasExtracts) {
            return React.createElement(SpacesMediumExtract_1.SvgSpacesMediumExtract, null);
        }
        else {
            return React.createElement(SpacesMediumDs_1.SvgSpacesMediumDs, null);
        }
    }
}
exports.DatasourceTypeCell = DatasourceTypeCell;
// tslint:disable-next-line: no-shadowed-variable
function GenerateCertificationTooltipComponent(isCertified, lastExtract, hasExtracts, certifier, certificationNote, linksDisabled, zIndex) {
    var date = lastExtract ? new Date(lastExtract) : undefined;
    var props = {
        isCertified: isCertified,
        hasExtracts: hasExtracts,
        certifier: certifier,
        extractLastUpdateTime: date,
        certificationNote: certificationNote,
        linksDisabled: linksDisabled,
        zIndex: zIndex,
    };
    return (React.createElement(DatasourceTypeCell, __assign({}, props)));
}
exports.GenerateCertificationTooltipComponent = GenerateCertificationTooltipComponent;
//# sourceMappingURL=DatasourceTypeCell.js.map